var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewBoxArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.125 35.156c0 .777-.63 1.407-1.406 1.407h-22.5c-.777 0-1.407-.63-1.407-1.407V9.844c0-.777.63-1.406 1.407-1.406h22.5c.776 0 1.406.63 1.406 1.406v5.625a1.406 1.406 0 0 0 2.813 0V9.844a4.219 4.219 0 0 0-4.22-4.219h-22.5A4.219 4.219 0 0 0 0 9.844v25.312a4.219 4.219 0 0 0 4.219 4.219h22.5a4.219 4.219 0 0 0 4.218-4.219v-5.625a1.406 1.406 0 0 0-2.812 0v5.625z",
    fill: "#007DD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.588 23.494c.55-.549.55-1.44 0-1.988l-8.437-8.438a1.406 1.406 0 0 0-1.99 1.989l6.038 6.037h-24.73a1.406 1.406 0 1 0 0 2.812h24.73l-6.037 6.037a1.406 1.406 0 0 0 1.989 1.989l8.437-8.438z",
    fill: "#007DD2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBoxArrowRight);
export default __webpack_public_path__ + "static/media/new-box-arrow-right.fd2baddde0c0de6dd782844d7d2ce010.svg";
export { ForwardRef as ReactComponent };